<div class="header">
  <div class="header-cont view-page title">
    <h2>{{itin_current.itin_name[current_lang]}} <mat-icon *ngIf="titleAudioPresent()" class="play-audio-icon" (click)="playAudio()" [title]="'single_itin.audio_icon' | translate">{{titleAudioPlaying ? 'stop' : 'volume_up'}}</mat-icon></h2>
    <span class="pdf-download">{{ 'single_itin.offline' | translate }}<a (click)="downloadPdf()">{{ 'single_itin.pdf' | translate }}</a></span>
    <a (click)="downloadPdf()" class="icon-pdf-download"><mat-icon>picture_as_pdf</mat-icon></a>
  </div>
</div>

<div class="single-section">
  <div class="section-cont view-page address">
    <a (click)="routerFunction(itin_current.geopos)">
      {{itin_current.geopos[0].name[current_lang]}}
    </a>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-carousel
      #matCarousel
      [timings]="timings"
      [autoplay]="autoplay"
      [interval]="interval"
      [loop]="loop"
      [hideArrows]="hideArrows"
      [hideIndicators]="hideIndicators"
      [color]="color"
      [maxWidth]="maxWidth"
      [proportion]="proportion"
      [useKeyboard]="useKeyboard"
      [useMouseWheel]="useMouseWheel"
      [orientation]="orientation"
      [slides]="slides"
      [maintainAspectRatio]="maintainAspectRatio"
      [slideHeight]="slideHeight"
    >
      <ng-container *ngIf="exist_images; else noAttPic">
        <mat-carousel-slide
          #matCarouselSlide
          *ngFor="let pic of singleTypeAttachments(itin_current.attachments, 'picture'), let i = index"
          [image]="pic.file_byte"
          [overlayColor]="overlayColor"
          [hideOverlay]="hideOverlay"
        >
          <div class="carousel">
            <div class="carousel-cont">
              <button
                mat-raised-button
                (click)="openImage(i)">
                <mat-icon>zoom_in</mat-icon>
              </button>
            </div>
          </div>
        </mat-carousel-slide>
      </ng-container>
      <ng-template #noAttPic>
        <mat-carousel-slide
          #matCarouselSlide
          image="../../../assets/home/no-picture.png"
          [overlayColor]="overlayColor"
          [hideOverlay]="hideOverlay"
        >
        </mat-carousel-slide>
      </ng-template>
    </mat-carousel>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'single_itin.descr' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <p style="white-space: pre-wrap;">{{itin_current.description[current_lang]}}</p>
  </div>
</div>

<div *ngIf="itin_current.trivia[current_lang]">
  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'single_itin.trivia' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <p style="white-space: pre-wrap;">{{itin_current.trivia[current_lang]}}</p>
    </div>
  </div>
</div>

<div class="single-section">
  <div class="section-cont view-page map">
    <div #map class="google-map"></div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'single_itin.pois' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <div class="element-card">
      <mat-card *ngFor="let single_poi of itin_current.pois" [routerLink]="['/home/poi/' + single_poi.id]">
        <img mat-card-image [src]="poiImageUrl(single_poi)">
        <mat-card-content>
          <a><h4>{{single_poi.poi_name[current_lang]}}</h4></a>
          <p>{{single_poi.short_descr[current_lang]}}</p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<div *ngIf="checkIfAttachments(itin_current.attachments)">
  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'single_itin.allegati' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont view-page accordions">
      <div class="first-row"
        *ngIf="checkAttachments(itin_current.attachments, 'audio') || checkAttachments(itin_current.attachments, 'document') || checkAttachments(itin_current.attachments, 'video', true)">
        <mat-accordion *ngIf="checkAttachments(itin_current.attachments, 'audio')">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="att-title">
                <mat-icon>volume_up</mat-icon> {{ 'single_itin.audio' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngIf="checkAttachments(itin_current.attachments, 'audio'); else noAttAud">
              <a class="att-title between" *ngFor="let audio of singleTypeAttachments(itin_current.attachments, 'audio')" (click)="downloadAtt(audio)">
                <span><mat-icon>{{(!!attachmentAudioPlaying && attachmentAudioPlaying == audio?.id) ? 'stop' : 'graphic_eq'}}</mat-icon> {{audio.name}}</span>
                <mat-icon class="no-attach icon" [title]="audio.source">help</mat-icon>
              </a>
            </ng-container>
            <ng-template #noAttAud>
              <p class="no-attach">
                <span>{{ 'single_itin.no_audio' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
              </p>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion *ngIf="checkAttachments(itin_current.attachments, 'document')">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="att-title">
                <mat-icon>description</mat-icon> {{ 'single_itin.docs' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngIf="checkAttachments(itin_current.attachments, 'document'); else noAttDoc">
              <a class="att-title between" *ngFor="let doc of singleTypeAttachments(itin_current.attachments, 'document')" (click)="downloadAtt(doc)">
                <span><mat-icon>subject</mat-icon> {{doc.name}}</span>
                <mat-icon class="no-attach icon" [title]="doc.source">help</mat-icon>
              </a>
            </ng-container>
            <ng-template #noAttDoc>
              <p class="no-attach">
                <span>{{ 'single_itin.no_docs' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
              </p>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion *ngIf="(!checkAttachments(itin_current.attachments, 'audio') || !checkAttachments(itin_current.attachments, 'document')) && checkAttachments(itin_current.attachments, 'video', true)">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="att-title">
                <mat-icon>videocam</mat-icon> {{ 'single_itin.video' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngIf="checkAttachments(itin_current.attachments, 'video', true); else noAttVideo">
              <a class="att-title between" *ngFor="let video of singleTypeAttachments(itin_current.attachments, 'video', true)" (click)="downloadAtt(video)">
                <span><mat-icon>movie</mat-icon> {{video.name}}</span>
                <mat-icon class="no-attach icon" [title]="video.source">help</mat-icon>
              </a>
            </ng-container>
            <ng-template #noAttVideo>
              <p class="no-attach">
                <span>{{ 'single_itin.no_video' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
              </p>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="second-row"
        [ngClass]="{'exist-attachments': checkAttachments(itin_current.attachments, 'audio') && checkAttachments(itin_current.attachments, 'document')}"
        *ngIf="checkAttachments(itin_current.attachments, 'audio') && checkAttachments(itin_current.attachments, 'document') && checkAttachments(itin_current.attachments, 'video', true)">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="att-title">
                <mat-icon>videocam</mat-icon> {{ 'single_itin.video' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngIf="checkAttachments(itin_current.attachments, 'video', true); else noAttVideo">
              <a class="att-title between" *ngFor="let video of singleTypeAttachments(itin_current.attachments, 'video', true)" (click)="downloadAtt(video)">
                <span><mat-icon>movie</mat-icon> {{video.name}}</span>
                <mat-icon class="no-attach icon" [title]="video.source">help</mat-icon>
              </a>
            </ng-container>
            <ng-template #noAttVideo>
              <p class="no-attach">
                <span>{{ 'single_itin.no_video' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
              </p>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="second-row"
        [ngClass]="{'exist-attachments': checkAttachments(itin_current.attachments, 'audio') || checkAttachments(itin_current.attachments, 'document') || checkAttachments(itin_current.attachments, 'video', true)}"
        *ngIf="videos.length > 0">
        <div class="video-container" *ngFor="let video of videos">
          <iframe [src]="video" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="itin_current.themes?.length > 0">
  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'single_itin.theme' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont view-page accordions">
      <div class="first-row">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="att-title">
                <mat-icon>filter_list</mat-icon> {{ 'single_itin.theme' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngIf="itin_current.themes?.length > 0; else noThemes">
              <p class="att-title between" *ngFor="let theme of itin_current.themes">
                <span><mat-icon>label</mat-icon> {{theme.name[current_lang]}}</span>
              </p>
            </ng-container>
            <ng-template #noThemes>
              <p class="no-attach">
                <span>{{ 'single_itin.no_theme' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
              </p>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
